import {
  Directive,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
} from "@angular/core";
import { PopOverComponent } from "./pop-over.component";
import { Observable, fromEvent, merge, EMPTY } from "rxjs";

@Directive({
  selector: "[pop-over-trigger]",
})
// tslint:disable-next-line:directive-class-suffix
export class PopOverTrigger implements OnInit, OnChanges {
  @Input("pop-over-trigger") popover: PopOverComponent;
  @Input("show-on") showOn: string;
  @Input("hide-on") hideOn: string;

  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty("showOn")) {
      this.setShowOn();
    }
    if (changes.hasOwnProperty("hideOn")) {
      this.setHideOn();
    }
  }

  private setHideOn(): void {
    if (this.popover) {
      if (this.hideOn) {
        this.popover.hideOn = merge(
          ...this.hideOn
            .split(",")
            .map((eventType) => eventType.trim())
            .map(
              (eventType: string): Observable<MouseEvent> =>
                fromEvent<MouseEvent>(this.elRef.nativeElement, eventType),
            ),
        );
      } else {
        this.popover.hideOn = EMPTY;
      }
    }
  }

  private setShowOn(): void {
    if (this.popover) {
      if (this.showOn) {
        this.popover.showOn = merge(
          ...this.showOn
            .split(",")
            .map((eventType) => eventType.trim())
            .map(
              (eventType: string): Observable<MouseEvent> =>
                fromEvent<MouseEvent>(this.elRef.nativeElement, eventType),
            ),
        );
      } else {
        this.popover.showOn = EMPTY;
      }
    }
  }
}
